var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTiktokBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H32C40.8366 0 48 7.16344 48 16V32C48 40.8366 40.8366 48 32 48H16C7.16344 48 0 40.8366 0 32V16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 21.8438C32.3906 21.8906 30.4219 21.2344 28.7344 20.0156V28.4062C28.7344 34.2656 22.3594 37.9219 17.2969 35.0156C12.2344 32.0625 12.2344 24.75 17.2969 21.7969C18.75 20.9531 20.4844 20.625 22.1719 20.8594V25.0781C19.5938 24.2344 17.1094 26.5312 17.6719 29.1562C18.2812 31.7812 21.4688 32.8125 23.4844 30.9844C24.1875 30.3281 24.6094 29.3906 24.6094 28.4062V12H28.7344C28.7344 12.375 28.7344 12.7031 28.8281 13.0781C29.1094 14.625 30 15.9844 31.3594 16.8281C32.25 17.4375 33.375 17.7656 34.5 17.7656V21.8438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTiktokBg);
export default __webpack_public_path__ + "static/media/icTiktokBg.12aa8618f506d8a6937c703c0c5707af.svg";
export { ForwardRef as ReactComponent };